import { defineCustomElement } from 'vue'
import Bubble from './features/Bubble/components/Bubble.vue'
import { defaultBubbleProps } from './constants'
import styles from './styles.css?inline'

// @ts-expect-error  vendor
const MyHotspot = defineCustomElement({ ...Bubble, props: defaultBubbleProps, styles: [styles] })

export function registerWebComponents() {
  if (typeof window === 'undefined')
    return
  customElements.define('beeetle-bubble', MyHotspot)
}
